import mutations from "@/store/mutations";

describe("Mutations", () => {
  let state;

  beforeEach(() => {
    state = {
      route: null,
      isLoading: false,
      paso1: null,
      responseConsulta: null,
      paso2: null,
      paso3: null,
      paso4: null,
      trackClickElement: null,
      trackOnClickStart: null,
      isExceeded: false,
      mock: null,
      notificationToast: null
    };
  });

  it("should set the route in the state", () => {
    const payload = "/home";
    mutations["ON_ROUTE"](state, payload);
    expect(state.route).toBe(payload);
  });

  it("should set the isLoading state", () => {
    const payload = true;
    mutations["ON_IS_LOADING"](state, payload);
    expect(state.isLoading).toBe(true);
  });

  it("should set the paso1 state", () => {
    const payload = "step1";
    mutations["ON_PASO_1"](state, payload);
    expect(state.paso1).toBe(payload);
  });

  it("should set the responseConsulta state", () => {
    const payload = "responseConsulta";
    mutations["ON_PASO_1_SUCCESS"](state, payload);
    expect(state.responseConsulta).toBe(payload);
  });

  it("should set the paso2 state", () => {
    const payload = "step2";
    mutations["ON_PASO_2"](state, payload);
    expect(state.paso2).toBe(payload);
  });

  it("should set the paso3 state", () => {
    const payload = "step3";
    mutations["ON_PASO_3"](state, payload);
    expect(state.paso3).toBe(payload);
  });

  it("should set the paso4 state", () => {
    const payload = "step4";
    mutations["ON_PASO_4"](state, payload);
    expect(state.paso4).toBe(payload);
  });

  it("should set the trackClickElement state", () => {
    const payload = "trackClickElement";
    mutations["ADOBE_APP_STARTED"](state, payload);
    expect(state.trackClickElement).toBe(payload);
  });

  it("should set the trackOnClickStart state", () => {
    const payload = "trackOnClickStart";
    mutations["ADOBE_APP_ON_CLICK_START"](state, payload);
    expect(state.trackOnClickStart).toBe(payload);
  });

  it("should set the isExceeded state", () => {
    const payload = "isExceeded";
    mutations["ON_IS_EXCEEDED"](state, payload);
    expect(state.isExceeded).toBe(payload);
  });

  it("should set the mock state", () => {
    const payload = "mock";
    mutations["ON_MOCK"](state, payload);
    expect(state.mock).toBe(payload);
  });

  it("should set the notificationToast state", () => {
    const payload = "notificationToast";
    mutations["ON_NOTIFICATION_TOAST"](state, payload);
    expect(state.notificationToast).toBe(payload);
  });
});
